// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home/index.tsx";
import About from "./Pages/About/index.tsx";
import Services from "./Pages/Service/index.tsx";
import Contact from "./Pages/Contactus/index.tsx";
import Career from "./Pages/Career/index.tsx";
import Team from "./Pages/Team/index.tsx";

import Award from "./Pages/Awards/index.tsx";
import ScrollToTop from "./Components/ScrollToTop/index.tsx"



function App() {
  return (
<>
    <Router>
    <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/career" element={<Career />} />
        <Route path="/awards" element={<Award/>} />
        <Route path="/team" element={<Team/>} />
      
      </Routes>
    </Router>
    </>
  );
}

export default App;
